export var ERROR_PATH;
(function (ERROR_PATH) {
    ERROR_PATH["PAGE_ERROR"] = "/error";
    ERROR_PATH["PAGE_404"] = "/error/404";
    ERROR_PATH["PAGE_UNAUTHORISED"] = "/error/403";
    ERROR_PATH["PAGE_PC_UNAUTHORISED"] = "/error/partnercenter/403";
})(ERROR_PATH || (ERROR_PATH = {}));
